
import React from 'react';

import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { NavBarChild } from './';
import Auth from '../../services/AuthService';
import { HomeAnnatelURL } from '../../localeAssets';
import { Internet } from '../../images';
import { MyServicesIcon, ProfileIcon, InvoicesIcon, SignOutIcon }  from '../Icons';

const NavSidebarItems = (location, translate, match, currentLanguage, dispatch) => {
  let personalInfoClass = classNames({
    'nav-item': true,
    'ng-scope': true,
    'active': (location.pathname.includes("/personalinfo"))
  });
  let billsClass = classNames({
    'nav-item': true,
    'ng-scope': true,
    'active': (location.pathname.includes("/bills/"))
  });
  let servicesClass = classNames({
    'nav-item': true,
    'ng-scope': true,
    'active': (location.pathname.includes("/services/"))
  });
  const closeNavbar = () => {
    window.jQuery('#top-menu').removeClass('show');
  }
  return (
    <ul className="navbar-nav">
      <li className={servicesClass} ng-repeat="nav in vm.nav" ui-sref-active="active">
        <Link className="nav-link" to={`/${currentLanguage}/services/lines-mobile`} >
          <MyServicesIcon />
          <span className="ng-binding nav-link-text"> {translate('my-services')} </span>
        </Link>
        {NavBarChild(location, translate, currentLanguage)}
      </li>
      <li className={personalInfoClass} ng-repeat="nav in vm.nav" ui-sref-active="active">
        <Link className="nav-link" ui-sref="personal-information" to={`/${currentLanguage}/personalinfo`} match={match} onClick={() => { closeNavbar() }}>
          <ProfileIcon />
          <span className="ng-binding nav-link-text">{translate('profile')}</span>
        </Link>
      </li>
      <li className={billsClass} ng-repeat="nav in vm.nav" ui-sref-active="active" >
        <Link className="nav-link" ui-sref="bills" to={`/${currentLanguage}/bills/1`} onClick={() => { closeNavbar() }}>
          <InvoicesIcon />
          <span className="ng-binding nav-link-text">{translate('invoices')}</span>
        </Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link" ui-sref="login" to={`/${currentLanguage}/auth/login`} onClick={() => Auth.logOut(dispatch)}>
          <SignOutIcon />
          <span className="nav-link-text">{translate('sign-out')}</span>
        </Link >
      </li>
      <li className="nav-item d-lg-none">
        <a className="nav-link" href={HomeAnnatelURL()}>
          <span>{`${translate('go-back-to-the-Annatel-website')} `}<img  alt="LOGO" style={{height: '2em'}} src={Internet} /></span>
        </a>
      </li>
    </ul>
  );
}
export default NavSidebarItems;



// WEBPACK FOOTER //
// ./src/components/Navigation/NavSidebarItems.js